import React from "react";
import BdayIndex from "../pages/bday/Index";
import { BdayStateProvider } from "../contexts/BdayStateContext";
import "../styles/bday.css";

const Bday = () => {
  return (
    <div className="bday-container">
      <BdayStateProvider>
        <BdayIndex />
      </BdayStateProvider>
    </div>
  );
};

export default Bday;
